namespace HA.Core.Entity {
    export class HANavigationApp extends App {

        public updateInfo(data: Map<string, any>) {
        }

        public intro(): void {
            super.intro();
            if (this.hasNot("location")) {
                getDataRepository().saveLocation();
            }
        }
    }
}
